import Choices from 'choices.js';
class PageAccount {
  private profil: HTMLDivElement;
  private uploadButton!: HTMLButtonElement;
  private fileInput!: HTMLInputElement;
  private photoAccount!: HTMLImageElement;
  private photoHeader!: HTMLImageElement;
  private photoHeaderMobile!: HTMLImageElement;
  private removeButton!: HTMLButtonElement;
  private selectLoisirs!: HTMLSelectElement;
  private fieldBirthday!: HTMLInputElement;

  constructor() {
    this.profil = document.querySelector(".page-account") as HTMLDivElement;
    if (this.profil) {
      this._init();
    }
  }

  _init() {
    this.uploadButton = this.profil.querySelector(".page-account__edit-button") as HTMLButtonElement;
    this.fileInput = this.profil.querySelector(".page-account__edit-input") as HTMLInputElement;
    this.photoAccount = this.profil.querySelector(".page-account__img-profil") as HTMLImageElement;
    this.photoHeader = document.querySelector('.header-primary__account') as HTMLImageElement;
    this.photoHeaderMobile = document.querySelector('.header-primary__mobile--account') as HTMLImageElement;
    this.removeButton = this.profil.querySelector(".page-account__delete-pic") as HTMLButtonElement;
    this.selectLoisirs = this.profil.querySelector(".page-account__multi-select-container select") as HTMLSelectElement;
    this.fieldBirthday = this.profil.querySelector(".page-account__card-input") as HTMLInputElement;
    this._addPhoto();
    this._removePhoto();
    this._loisirs();
    this._birthday();
  }

  _addPhoto() {

    this.uploadButton.addEventListener("click", async (event: MouseEvent) => {
      event.preventDefault()
      this.fileInput.click(); // Ouvre la boîte de dialogue de sélection de fichier
    });

    this.fileInput.addEventListener("change", async () => {
      const file = this.fileInput.files?.[0];
      // Vérifie si un fichier est sélectionné
      if (!file) {
        return;
      }

      // Vérifie le type de fichier
      const allowedTypes = ["image/jpeg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        alert("Seuls les fichiers JPG et PNG sont autorisés.");
        return;
      }

      // Prépare les données pour l'upload
      const formData = new FormData();
      formData.append("action", "user_photo_upload");
      formData.append("file", file);
      formData.append("nonce", (window as any).ajax.nonce);

      try {
        const response = await fetch((window as any).ajax.ajax_url, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (result.success) {
          const src = result.data;
          this.photoAccount.src = src;
          this.photoHeader.src = src;
          this.photoHeaderMobile.src = src;
          this.removeButton.classList.remove('hidden')
        } else {
          console.error("Erreur lors de l'upload :", result.data);
        }
      } catch (error) {
        console.error("Erreur réseau ou serveur :", error);
      }
    });



  }

  _removePhoto() {
    const removeButton = this.profil.querySelector(".page-account__delete-pic") as HTMLButtonElement;

    removeButton.addEventListener("click", async (event: MouseEvent) => {
      event.preventDefault()

      // Prépare les données pour l'upload
      const formData = new FormData();
      formData.append("action", "user_photo_remove");
      formData.append("nonce", (window as any).ajax.nonce);

      try {
        // Effectue la requête AJAX
        const response = await fetch((window as any).ajax.ajax_url, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (result.success) {
          const src = result.data;
          this.photoAccount.src = src;
          this.photoHeader.src = src;
          this.photoHeaderMobile.src = src;
          removeButton.classList.add('hidden')
        } else {
          console.error("Erreur lors de la suppression :", result.data);
        }
      } catch (error) {
        console.error("Erreur réseau ou serveur :", error);
      }
    });
  }

  _loisirs() {
    const loisirs = new Choices(this.selectLoisirs, {
      itemSelectText: '',
      searchEnabled: true,
      searchChoices: true,
      removeItemButton: true,
      maxItemCount: 3,
      closeDropdownOnSelect: true,
      maxItemText: (maxItemCount) => {
        return `Ajout de ${maxItemCount} loisirs maximum`;
      },
    });


    this.selectLoisirs.addEventListener("change", async () => {
      const selectedOptions = Array.from(this.selectLoisirs.selectedOptions);
      const selectedValues = selectedOptions.map(option => option.value);

      // Prépare les données pour l'upload
      const formData = new FormData();
      formData.append("action", "user_loisirs");
      formData.append("loisirs", JSON.stringify(selectedValues));
      formData.append("nonce", (window as any).ajax.nonce);

      try {
        const response = await fetch((window as any).ajax.ajax_url, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (!result.success) {
          console.error("Erreur lors de la mise à jour des loisirs :", result.data);
        }
      } catch (error) {
        console.error("Erreur réseau ou serveur :", error);
      }
    })
  }

  _birthday() {
    this.fieldBirthday.addEventListener("change", async () => {
      const value = this.fieldBirthday.value;

      // Prépare les données pour l'upload
      const formData = new FormData();
      formData.append("action", "user_birthday");
      formData.append("birthday", JSON.stringify(value));
      formData.append("nonce", (window as any).ajax.nonce);

      try {
        const response = await fetch((window as any).ajax.ajax_url, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (!result.success) {
          console.error("Erreur lors de la mise à jour de l'anniversaire :", result.data);
        }
      } catch (error) {
        console.error("Erreur réseau ou serveur :", error);
      }
    })
  }


}

export const pageAccount = new PageAccount();
